import { useState } from "react";
import { resetPassword } from "../api/auth";

export default function ResetPassword() {
  const params = new URLSearchParams(window.location.search);
  const token = params.get("token") || "";
  const emailFromUrl = params.get("email") || "";

  const [email, setEmail] = useState(emailFromUrl);
  const [password, setPassword] = useState("");
  const [passwordConfirmation, setPasswordConfirmation] = useState("");
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    setLoading(true);
    setMessage("");
    setError("");

    if (password !== passwordConfirmation) {
      setError("Passwords do not match.");
      setLoading(false);
      return;
    }

    try {
      await resetPassword(
        email,
        token,
        password,
        passwordConfirmation
      );

      localStorage.removeItem("legal_portal_user");

      window.location.href = "/login";
    } catch (err) {
      setError(err.response?.data?.message || "Unable to reset password.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page">
      <div className="login-card">
        <div className="d-flex align-items-center gap-3 mb-4">
          <div className="brand-mark">CV</div>

          <div>
            <h4 className="mb-0">CounselVault</h4>
            <div className="text-muted small">
              Secure privileged legal mail infrastructure
            </div>
          </div>
        </div>

        <div className="mb-4">
          <h2 className="fw-bold mb-2">Reset Password</h2>
          <p className="text-muted mb-0">
            Create a new password for your CounselVault account.
          </p>
        </div>

        {message && <div className="alert alert-success py-2">{message}</div>}
        {error && <div className="alert alert-danger py-2">{error}</div>}

        {!token ? (
          <div className="alert alert-danger">
            Missing reset token. Please request a new password reset link.
          </div>
        ) : (
          <form onSubmit={handleSubmit}>
            <div className="mb-3">
              <label className="form-label">Email Address</label>
              <input
                className="form-control form-control-lg"
                type="email"
                autoComplete="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </div>

            <div className="mb-3">
              <label className="form-label">New Password</label>
              <input
                className="form-control form-control-lg"
                type="password"
                autoComplete="new-password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                minLength={12}
              />
              <div className="form-text">
                Password must be at least 12 characters.
              </div>
            </div>

            <div className="mb-4">
              <label className="form-label">Confirm New Password</label>
              <input
                className="form-control form-control-lg"
                type="password"
                autoComplete="new-password"
                value={passwordConfirmation}
                onChange={(e) => setPasswordConfirmation(e.target.value)}
                required
                minLength={12}
              />
            </div>

            <button className="btn btn-dark btn-lg w-100" disabled={loading}>
              {loading ? "Resetting..." : "Reset Password"}
            </button>
          </form>
        )}

        <div className="text-center mt-4">
          <a href="/login">Back to sign in</a>
        </div>
      </div>
    </div>
  );
}
